module.exports = __webpack_public_path__ + "img/somos_nuestros_resultados_INGLES_negro.b6fa3900.png";